import React, { useRef, useState, useEffect } from "react";
import Moment from 'react-moment';
import 'moment/locale/es';
import 'moment-timezone';
import moment from 'moment';
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt, faSignInAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import QrScanner from 'components/QrScanner';


import LoaderButton from "../components/LoaderButton";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

// import "./Show.css";

// const API_NAME = "offline"
const API_NAME = "vivelo"

// Helper function to convert UTC to Guatemala time
const formatGuatemalaTime = (dateString) => {
    if (!dateString) return '';
    return moment.utc(dateString).tz('America/Guatemala').format('DD/MM/YYYY HH:mm:ss');
};

export default function AdmissionControl({show, showTicket, showLocation, onClose, testMode=false, ...props}) {
    
    const [mode, setMode] = useState('checkin'); // 'checkin' or 'checkout'
    const [ticket, setTicket] = useState(null);
    const [status, setStatus] = useState('loading');

    const [isLoading, setIsLoading] = useState(false); 

    async function validateCode(code, show_uid, ticket_uid) {
        try {
            const operation = mode === 'checkout' ? 'checkout' : 'checkin';
            const requireCheckin = mode === 'checkout' ? '&requireCheckin=true' : '';
            const checkin = testMode ? '&checkin=0&checkout=0' : (mode === 'checkout' ? '&checkout=1' : '&checkin=1');
            const ticket = ticket_uid ? `&t=${ticket_uid}` : ''
            const location = showLocation ? `&l=${showLocation._id}` : ''
            const result = await API.get(API_NAME, `/etickets/qr/${operation}/${code}?s=${show_uid}${ticket}${location}${checkin}${requireCheckin}`);
            return result
        } catch (e) {
            console.log(e)
            if (e.response && e.response.data) {
                return e.response.data
            } else {
                return {
                    success: false,
                    allow_access: false,
                    error_code: 'API_ERROR'
                }
            }
        }
    }

    function handleStatusChange(status) {
        if (status.scanning) {
            setStatus('scanning')
            setTicket(null)
        }
    }

    async function handleOnSuccess(payload) {
        setStatus('validating')

        const show_uid = show._id
        const ticket_uid = null; //showTicket
        const code = payload.raw
        const result = await validateCode(code, show_uid, ticket_uid)

        if (result.success) {
            if (result.allow_access) {
                result.ticket.checkedin_on = result.checkedin
                result.ticket.checkedout_on = result.checkedout
                result.ticket.order = result.order
                setTicket(result.ticket)
                setStatus('accepted')
            } else {
                result.ticket.order = result.order
                result.ticket.checkedin_on = result.checkedin
                result.ticket.checkedout_on = result.checkedout
                setTicket(result.ticket)
                if (testMode) {
                    setStatus('accepted')
                } else {
                    setStatus('warning')
                }
            }
        } else {
            console.log(result)
            // Handle error cases with specific error codes
            if (result.error_code === 'PAYMENT_REQUIRED') {
                // NEW: Handle payment requirement
                result.ticket = result.ticket || {}
                result.ticket.error_code = result.error_code
                result.ticket.checkedin_on = result.checkedin
                result.ticket.checkedout_on = result.checkedout
                result.ticket.order = result.order || {}
                setTicket(result.ticket)
                setStatus('payment_required')
            } else if (result.error_code) {
                result.ticket = result.ticket || {}
                result.ticket.error_code = result.error_code
                result.ticket.checkedin_on = result.checkedin
                result.ticket.checkedout_on = result.checkedout
                result.ticket.order = result.order || {}
                setTicket(result.ticket)
                setStatus('already_admitted')
            } else if (result.checkedin || result.checkedout) {
                result.ticket.checkedin_on = result.checkedin
                result.ticket.checkedout_on = result.checkedout
                result.ticket.order = result.order
                setTicket(result.ticket)
                setStatus('already_admitted')
            } else {                                
                if (result.ticket) {
                    result.ticket.order = result.order || {}
                    result.ticket.checkedout_on = result.checkedout
                }
                setTicket(result.ticket)
                setStatus('rejected')
            }
        }
    }

    function getErrorMessage(errorCode, operationText) {
        switch(errorCode) {
            case 'PAYMENT_REQUIRED':
                return 'Pago requerido antes de la salida. Por favor visite la estación de pago.';
            case 'ALREADY_CHECKED_OUT':
                return `Ya registró ${operationText.toLowerCase()} anteriormente`;
            case 'CHECKIN_FAILED':
                return `No se pudo registrar ${operationText.toLowerCase()} - ya registrado o con salida previa`;
            case 'CHECKOUT_FAILED':
                return `No se pudo registrar ${operationText.toLowerCase()}`;
            case 'NO_PREVIOUS_CHECKIN':
                return `No se encontró ingreso previo para registrar ${operationText.toLowerCase()}`;
            case 'INVALID_CODE':
                return 'Código inválido';
            case 'INVALID_QR_FORMAT':
                return 'Formato de código QR inválido';
            case 'MISSING_CODE':
                return 'Falta el parámetro de código';
            case 'INTERNAL_ERROR':
                return 'Error interno del servidor';
            case 'API_ERROR':
                return 'Error de conexión con el servidor';
            default:
                return `Error al procesar ${operationText.toLowerCase()}`;
        }
    }

    function exitScanner() {
        setTicket(null)
        setStatus('loading')
        onClose()
    }

    function renderModeToggle() {
        // Only show mode toggle if checkout is enabled
        if (!show.settings.needs_checkout) {
            return null;
        }
        
        return (
            <div className="mode-toggle" style={{marginBottom: '15px', textAlign: 'center'}}>
                <ButtonGroup size="lg">
                    <Button 
                        variant={mode === 'checkin' ? 'primary' : 'outline-primary'}
                        onClick={() => setMode('checkin')}
                    >
                        <FontAwesomeIcon icon={faSignInAlt} /> Ingreso
                    </Button>
                    <Button 
                        variant={mode === 'checkout' ? 'primary' : 'outline-primary'}
                        onClick={() => setMode('checkout')}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} /> Salida
                    </Button>
                </ButtonGroup>
            </div>
        );
    }

    function renderStatusBar() {
        const operationText = mode === 'checkout' ? 'Salida' : 'Ingreso';
        
        switch(status) {
            case 'scanning':
                return <Alert variant="info">
                    <FontAwesomeIcon icon={faQrcode} /> 
                    Acerca el código a la cámara para {operationText.toLowerCase()}
                </Alert>
            case 'validating':
                return <Alert variant="primary">
                    <FontAwesomeIcon icon={faSpinner} className="spinning" /> 
                    Validando {operationText.toLowerCase()}...
                </Alert>
            case 'accepted':
                return <Alert variant="success">
                    <FontAwesomeIcon icon={faCheckCircle} /> 
                    {operationText} registrada exitosamente
                </Alert>
            case 'warning':
                return <Alert variant="warning">
                    <FontAwesomeIcon icon={faExclamationTriangle} /> 
                    Boleto válido. No registra {operationText.toLowerCase()}.
                </Alert>
            case 'rejected':
                return <Alert variant="danger">
                    <FontAwesomeIcon icon={faTimesCircle} /> 
                    Boleto inválido
                </Alert>
            case 'payment_required':
                return <Alert variant="warning">
                    <FontAwesomeIcon icon={faExclamationTriangle} /> 
                    {ticket && ticket.error_code ? getErrorMessage(ticket.error_code, operationText) : 'Pago requerido antes de la salida. Por favor visite la estación de pago.'}
                </Alert>
            case 'already_admitted':
                return <Alert variant="danger">
                    <FontAwesomeIcon icon={faTimesCircle} /> 
                    {ticket && ticket.error_code ? getErrorMessage(ticket.error_code, operationText) : `Ya registró ${operationText.toLowerCase()} anteriormente`}
                </Alert>
            default: 
                return <Alert variant="primary">
                    <FontAwesomeIcon icon={faSpinner} className="spinning" /> 
                    Cargando...
                </Alert>
        }
    }

    function renderAdmissionScanner() {
        console.log(showTicket)

        const ticketBackground = ticket?.qr_color?.qr_light_color || 'FFFFFFFF'
        const ticketForeground = ticket?.qr_color?.qr_dark_color || '000000FF'
        const ticketPadding = ticket?.qr_color?.qr_dark_color ? '0px 5px' : ''

        // Determine layout class based on checkout settings
        const layoutClass = show.settings.needs_checkout ? 'with-mode-toggle' : 'default-layout'

        return show && <div className="scanner-container">                
                
                {showTicket && <div className={`show-admission ${layoutClass}`}>
                    <div className="show-admission-header">                        
                        <h1>{show.fullname}</h1>
                        <Button onClick={exitScanner} className="exit" variant="outline-light">Cerrar</Button>
                        <h2>{show?.settings?.hasMap ? showTicket.fullname : `Escanear QR`}</h2>
                    </div>
                    
                    {renderModeToggle()}
                    
                    <div className={`show-admission-scanner ${status}`}>
                        <QrScanner 
                            size={250}
                            pattern="(VT01)([ABCDEFGHIJKLMNPQRSTUVWXYZ123456789]{6})([ABCDEFGHIJKLMNPQRSTUVWXYZ123456789]{4})([ABCDEFGHIJKLMNPQRSTUVWXYZ123456789]{6})"
                            onSuccess={handleOnSuccess}
                            onStatusChange={handleStatusChange}
                        />
                    </div>
                    <div className="show-admission-result">
                        <div>
                            {renderStatusBar()}
                        </div>
                        <div className="show-admission-ticket-info">
                        {ticket && <div className="ticket-data" style={{background:`#${ticketBackground}`,color:`#${ticketForeground}`}}>                            
                            <div className="ticket-data-item"><label>Boleto</label><span 
                                style={{fontSize:'1.8rem',fontWeight:'bold'}}>
                                    {ticket.ticket_name}
                            </span></div>
                            <div className="ticket-data-item"><label>Código</label><span>{ticket.code}</span></div>
                        </div> }
                        
                        {ticket && <div className="ticket-data">
                            <div className="ticket-data-item"><label>Sección</label><span>{ticket.section}</span></div>
                            <div className="ticket-data-item"><label>Puerta</label><span>{ticket.door}</span></div>                            
                        </div> }
                        
                        {ticket && ticket.row && ticket.seat && <div className="ticket-data">
                            <div className="ticket-data-item"><label>Fila</label><span>{ticket.row}</span></div>
                            <div className="ticket-data-item"><label>Asiento</label><span>{ticket.seat}</span></div>
                        </div> }
                        
                        {ticket && ticket.order && <div className="ticket-data">
                            <div className="ticket-data-item"><label>Nombre</label><span>{`${ticket.order.firstname} ${ticket.order.lastname}`}</span></div>
                            <div className="ticket-data-item"><label>Email</label><span>{ticket.order.email}</span></div>
                        </div> }
                        
                        {/* Checkin Status - Always show */}
                        {ticket && <div className="ticket-data">
                            <div className="ticket-data-item">
                                <label>Estado Ingreso</label>
                                {ticket.checkedin_on ? (
                                    <div>
                                        <Badge variant="success" pill>ADMITIDO</Badge>
                                        <span style={{fontSize: 12, marginLeft: 5}}>
                                            {formatGuatemalaTime(ticket.checkedin_on)}
                                        </span>
                                    </div>
                                ) : (
                                    <Badge variant="secondary" pill>PENDIENTE</Badge>
                                )}
                            </div>
                        </div> }
                        
                        {/* Checkout Status - Only show if enabled in show settings */}
                        {ticket && show.settings.needs_checkout && <div className="ticket-data">
                            <div className="ticket-data-item">
                                <label>Estado Salida</label>
                                {ticket.checkedout_on ? (
                                    <div>
                                        <Badge variant="info" pill>SALIDA REGISTRADA</Badge>
                                        <span style={{fontSize: 12, marginLeft: 5}}>
                                            {formatGuatemalaTime(ticket.checkedout_on)}
                                        </span>
                                    </div>
                                ) : ticket.checkedin_on ? (
                                    <Badge variant="warning" pill>PENDIENTE</Badge>
                                ) : (
                                    <Badge variant="secondary" pill>SIN INGRESO</Badge>
                                )}
                            </div>
                        </div> }
                        
                        {/* Summary Status */}
                        {ticket && show.settings.needs_checkout && (
                            <div className="ticket-data ticket-summary">
                                <div className="ticket-data-item">
                                    <label>Resumen</label>
                                    <div className="status-summary">
                                        {ticket.checkedin_on && ticket.checkedout_on ? (
                                            <Badge variant="success">COMPLETO</Badge>
                                        ) : ticket.checkedin_on ? (
                                            <Badge variant="warning">SÓLO INGRESO</Badge>
                                        ) : (
                                            <Badge variant="secondary">SIN REGISTRO</Badge>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>
                </div> }
        </div>
    }

    return renderAdmissionScanner()

}